import { render, staticRenderFns } from "./CheckListComponent.vue?vue&type=template&id=6d620020&"
import script from "./CheckListComponent.vue?vue&type=script&lang=js&"
export * from "./CheckListComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports